import React from 'react';
import List from '@material-ui/core/List';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/styles";
import Suggestion from "components/explore/prospector/search/Suggestion";
import { Divider, ListSubheader, Button } from '@material-ui/core';
import { Constants } from 'utilities/constants';
import { Link } from "react-router-dom";

const useStyles = makeStyles({
    root: {
        padding: '2px 4px',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: 800,
        width: "100%",
        minHeight: 100,
        flexDirection: "column"
    },
    addProspect: {
        marginTop: '1rem'
    }
});

export default function SuggestionList({ suggestions }) {
    const classes = useStyles();
    let results;
    function renderSuggestions(suggestions) {
        return (
            <List>
                {recentSuggestion()}
                <ListSubheader>Suggestions</ListSubheader>
                {suggestions.map(s => <Suggestion suggestion={s} key={s.description} />)}
            </List>
        );
    }
    
    function renderNoResults() {
        console.log('Render No Results');
        const href = `${Constants.Routes.EXPLORE_PROSPECTOR_ADD_PROPERTY}/manual`;
        return (
            <>
                <Typography color="initial" variant="h5">No Suggestions Available.</Typography>
                <Button component={Link} variant="contained" color="primary" to={href} className={classes.addProspect}>Add Prospect</Button>
            </>
        )
    }
    
    function renderNullResults() {
        return <Typography variant="h5">Enter an address...</Typography>
    }
    
    function recentSuggestion() {
        const recentSuggestion = JSON.parse(
            localStorage.getItem('recentSuggestion')
        );
        return recentSuggestion ? (
            <>
                <ListSubheader>Recent</ListSubheader>
                <Suggestion suggestion={recentSuggestion} /> <Divider />
            </>
        ) : null;
    }
    if (suggestions == null)
        results = renderNullResults();
    else if (suggestions.length < 1)
        results = renderNoResults();
    else
        results = renderSuggestions(suggestions);
    return (
        <div className={classes.root}>
            {results}
        </div>
    )
}